import './each-cancellation-2023.css'
const EachCancellation2023 = ({cancellation, family, editCancellationDetails, changeCancellationStudent}) => {

    const changeStudent = (val) => {
        let selectedStudent = family.listOfFamilyStudents.find((student) => student.studentName === val && student)
        changeCancellationStudent(cancellation.id, selectedStudent.studentName)
    }

    return(
        <div className="each-cancellation-2023">
            <select className="each-cancellation-2023__student-name" value={cancellation.student} onChange={(e) => changeStudent(e.target.value)} >
                {family.listOfFamilyStudents.map((student) => <option key={student.studentId} value={student.studentName}>{student.studentName}</option>)}
            </select>
            <input className="each-cancellation-2023__lesson-date" value={cancellation.date} onChange={(e) => editCancellationDetails(cancellation.id, 'date', e.target.value)} />
            <select className="each-cancellation-2023__cancellor" value={cancellation.cancellor} onChange={(e) => editCancellationDetails(cancellation.id, 'cancellor', e.target.value)}>
                <option default value="0">Cancelled by</option>
                <option value="student">Student</option>
                <option value="teacher">Teacher</option>
                <option value="student less than 24hrs">Student&lt;24hr</option>
                <option value="sus-cancellation">Suspected Cancellation</option>
            </select>
            {cancellation.cancellor === "student less than 24hrs" && <input className="each-cancellation-2023__lesson-length" value={cancellation.lessonLength} onChange={(e) => editCancellationDetails(cancellation.id, 'lessonLength', e.target.value)} />}
        </div>
    )
}
export default EachCancellation2023